/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accLinkDetailsTable', [
        '$modal',
        '$rootScope',
        '$translate',
        'confirmAction',
        'DateTools',
        'NodeShareLink',
        'template',
        ($modal, $rootScope, $translate, confirmAction, DateTools, NodeShareLink, template) => ({
            scope: {
                links: '=',
                caption: '@',
                showEsignatureColumns: '<',
                element: '<',
                reload: '&'
            },
            templateUrl: template('links/details_table'),
            controller: ['$scope', function ($scope) {
                $scope.openViewEditModal = (link) => {
                    // It's important to inherit the scope from the $rootScope.
                    // Otherwise, child scopes won't have an access to $$phase property,
                    // which can leads to "$digest already in progress" error
                    const modalScope = $rootScope.$new();
                    modalScope.link = link;

                    $modal.open({
                        domOptions: {
                            modalType: 'confirm',
                            modalAction: 'view_edit',
                            modalBodyTemplate: 'links/view_edit',
                            modalFooterTemplate: 'links/_view_edit_modal_footer',
                            modalTitle: $translate.instant('Shared link to %{filename}', { filename: $scope.element.name }),
                            modalSubTitle: link.esignature != null ? `${$translate.instant('Revision')} ${link.node_revision}` : null,
                            modalNotifications: true
                        },
                        windowClass: 'edit-link-dialog',
                        controller: 'ViewEditLinkModalController',
                        keyboard: false,
                        backdrop: 'static',
                        scope: modalScope
                    }).result.then(() => $scope.reload());
                };

                $scope.revokeLink = (link) => {
                    let confirmationTranslationKey;
                    let confirmationTranslationProps;

                    if (link.days_until_expiration) {
                        confirmationTranslationKey = 'Are you sure you want to permanently revoke access to link: %{filename} that expires on %{date}?'
                        confirmationTranslationProps = {
                            filename: `*${$scope.element.name}*`,
                            date: `*${link.getExpirationDateFormatted()}*`
                        };
                    } else {
                        confirmationTranslationKey = 'Are you sure you want to permanently revoke access to link: %{filename}?';
                        confirmationTranslationProps = { filename: `*${$scope.element.name}*` };
                    }

                    confirmAction($scope, {
                        confirmTitle: $translate.instant('Are You Sure?'),
                        confirmBody: $translate.instant(confirmationTranslationKey, confirmationTranslationProps)
                    })
                        .then(() => NodeShareLink.remove({ node_uuid: $scope.element.uuid, id: link.id }))
                        .then(() => link.deleted_at = DateTools.dateNow());
                };

                $scope.markChanged = (link) => link.changed = true;

                $scope.resetDaysUntilExpiration = (link) => {
                    link.days_until_expiration = '';
                    $scope.markChanged(link);
                };

                $scope.singleUseChangeDisabled = (link) => {
                    return !link.isEditable() ||
                        // link is 1-time use and non-1-time use links are disabled
                        (link.single_use && link.permissions.isSingleUseOnlyRequired());
                };
            }]
        })
    ]);
